module.exports = __webpack_public_path__ + "img/usd-circle.48312321.svg";